import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import MovieCard from "@/components/base/MovieCard";
import { movies } from "@/mocks/movies";

const picks = movies.slice(0, 8);

export default function MoviePicks() {
  return (
    <section>
      <SectionTitle
        title="影片推荐精选"
        subtitle="8部热门影片，评分与类型一目了然"
        extra={
          <Link
            to="/category/recommend"
            className="text-sm text-primary-700 hover:text-primary-800 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            更多影片
            <i className="ri-arrow-right-s-line" />
          </Link>
        }
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {picks.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}